import { createFileRoute, Outlet, useMatch } from "@tanstack/react-router"
import { z } from "zod"
import { AixContentHeader } from "@aix/ui"
import { AdminAssetJobList } from "~/components/Admin/AdminAssetJobList"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

/**
 * Search params are the SINGLE source of truth for the view/team/run selection — `queue-test`
 * (VM-892 C5) prints a direct link like
 *   /admin/asset-jobs?view=concurrency&teamId=<id>&debugRunId=qdbg-xxxx
 * so mirroring any of this into component state would desync the link on back/forward.
 */
const searchSchema = z
  .object({
    view: z.enum(["all", "concurrency"]).optional(),
    teamId: z.string().optional(),
    debugRunId: z.string().optional(),
  })
  .partial()

function AdminContent() {
  const isChildRoute = useMatch({ from: "/admin/asset-jobs/$id", shouldThrow: false })

  if (isChildRoute) {
    return <Outlet />
  }

  return (
    <>
      <CustomHead />
      <div className="container mx-auto space-y-6">
        <AixContentHeader className="px-8 pt-8">
          <h1 className="text-2xl font-bold">Asset Jobs</h1>
        </AixContentHeader>
        <AdminAssetJobList />
      </div>
    </>
  )
}

function AdminAssetJobsWrapper() {
  return (
    <SuperAdminLayout>
      <AdminContent />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/asset-jobs")({
  validateSearch: searchSchema,
  component: AdminAssetJobsWrapper,
})
